import React from 'react'
import { connect } from 'react-redux'
import Validator from 'validatorjs'

import BaseComponent from 'utils/BaseComponent'

import Input from 'components/Input'

import { userDataValid } from 'scenes/NewClient/actions'

import './styles.scss'

export class AccountData extends BaseComponent {
  static validationRules = {
    first_name: 'string|required|min:2',
    last_name: 'string|required|min:2',
    email: 'required|email',
    confirm_email: 'required|same:email'
  }

  constructor(props) {
    super(props)

    this._bind('_handleChange')

    this.state = {
      formData: {
        first_name: '',
        last_name: '',
        email: '',
        confirm_email: ''
      }
    }
  }

  _handleChange(e) {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e)
  }

  _validate(e) {
    let formData = {
      ...this.state.formData,
      [e.target.name]: e.target.value
    }
    const validator = new Validator(formData, AccountData.validationRules)
    this.props.userDataValid({
      dataOk: validator.passes(),
      formData: formData
    })
  }

  render() {
    return (
      <div className="section-container account-data">
        <p className="bold-text title">Datos de cuenta</p>
        <div>
          <div className="section-elements d-flex justify-content-between">
            <Input  onChange={this._handleChange}
                    id="first_name"
                    name="first_name"
                    errors={this.props.errors.first_name}
                    placeholder="Nombre(s)*"/>

            <Input  onChange={this._handleChange}
                    id="last_name"
                    name="last_name"
                    errors={this.props.errors.last_name}
                    placeholder="Apellidos*"/>
          </div>
          <div className="section-elements message d-flex justify-content-between">
            <p className="cl-achromatic-b-color">
              Este correo electrónico será usado por el cliente para iniciar
              sesión en la aplicación móvil. <span className="bold-text cl-achromatic-c-color">IMPORTANTE </span>
              verificar que este dato sea correcto.
            </p>
          </div>
          <div className="section-elements d-flex justify-content-between">
            <Input  onChange={this._handleChange}
                    id="email"
                    name="email"
                    errors={this.props.errors.email}
                    placeholder="Correo electrónico*"/>

            <Input  onChange={this._handleChange}
                    id="confirm_email"
                    name="confirm_email"
                    errors={this.props.errors.email}
                    placeholder="Confirmar correo electrónico*"/>
          </div>
        </div>
      </div>
    )
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    userDataValid: (user) => dispatch(userDataValid(user))
  }
}

export default connect(null, mapDispatchToProps)(AccountData)



// WEBPACK FOOTER //
// ./src/scenes/NewClient/components/AccountData/index.js